// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//const url = 'http://localhost/rafael/banco/api/public';
 const url = 'https://api.fizbank.com.br';
//const url = 'https://testes.bankis.com.br';
export const environment = {
  production: false,
  api: url + '/api',
  apiContas: url + '/api/contas',
  apiUsuarios: url + '/api/usuarios',
  apiCarteiras: url + '/api/carteiras',
  apiTarifa: url + '/api/tarifas',
  url:  url + '/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
